package pl.michal_cyran.brand_hub.subpages.main.services

import androidx.compose.runtime.Composable

data class ServiceItem(
    val id: String,
    val title: String,
    val description: String,
    val features: List<String>,
    val icon: @Composable () -> Unit,
    val link: String = "",
)
